module.exports = __webpack_public_path__ + "img/1.532fae52.png";